import React from 'react'
import { useTranslation } from 'react-i18next'
import PlaceholderPage from '../PlaceholderPage'

function HelpPage() {
  const { t } = useTranslation()
  return <PlaceholderPage title={t('help') || 'Help'} />
}

export default HelpPage
